export const MANAGE_USER_LICENSES_CERTIFICATIONS_REQUEST = 'MANAGE_USER_LICENSES_CERTIFICATIONS_REQUEST'
export const MANAGE_USER_LICENSES_CERTIFICATIONS_SUCCESS = 'MANAGE_USER_LICENSES_CERTIFICATIONS_SUCCESS'
export const MANAGE_USER_LICENSES_CERTIFICATIONS_FAILED = 'MANAGE_USER_LICENSES_CERTIFICATIONS_FAILED'